import React from 'react';
import { useIntl } from 'react-intl';
import { Select } from 'antd';
import { zIndex } from '../../theme/theme';

const { Option } = Select;

type SelectorLayoutProps = {
  style?: any;
  className?: string;
  mode?: 'multiple' | 'tags';
  value?: any;
  placeholder?: string;
  loading?: boolean;
  onSelect?: (value: string) => void;
  options: any[];
  keyPrefix: string;
};

const SelectorLayout: React.FC<SelectorLayoutProps> = ({
  style,
  className,
  mode = 'multiple',
  value,
  placeholder,
  loading,
  onSelect,
  options,
  keyPrefix,
}) => {
  const intl = useIntl();

  const _placeholder =
    placeholder ||
    intl.formatMessage({
      id: 'fleetadmin.searchBox.fallback.placeholder',
    });

  return (
    <div style={style} className={className}>
      <Select
        data-testid="BlockedReasonsSelector"
        mode={mode}
        allowClear={true}
        value={value}
        style={{ width: '100%' }}
        placeholder={_placeholder}
        optionFilterProp="children"
        dropdownStyle={{ zIndex: zIndex.dropDown }}
        loading={loading}
        onChange={onSelect}
      >
        {options.map((option) => (
          <Option
            data-testid={`BlockedReasonsSelector-option-${option.value}`}
            key={`${keyPrefix}-option-${option.value}`}
            value={option.value}
          >
            <img
              src={`/images/blocked-reasons/${option.value}.svg`}
              alt={option.label}
              style={{ marginRight: '16px', width: '14px', height: '14px' }}
            />
            {option.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default SelectorLayout;
